module.exports = {"this user_name has existed.":"Tên đăng nhập này đã tồn tại.","invalid email or user_name.":"Email hoặc tên đăng nhập không hợp lệ."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/vi/messages.json
// module id = HGYc
// module chunks = 23